import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import Chart from "react-google-charts";
import "./SankeyChart.scss";
// Ref: https://developers.google.com/chart/interactive/docs/gallery/histogram

const SankeyChart = (props: any) => {
  const { data } = props;
  const options = {
    title: "Total C02 Emissions Sankey Chart",
    curveType: "function",
    tooltip: { isHtml: true },
    legend: { position: "bottom" },
    hAxis: { minValue: 5 },
    sankey: {
      iterations: 0,
      node: {
        // colors:[
        //   // '#EDBB5E','#59CD8F','#5496EF'
        //  '#111111','#000000', '#000000'
        // ]
      },
    },

    // enableInteractivity: true
  };

  // useEffect(() => {
  //   const chartWrapper = chartWrapperRef.current;
  //   if (chartWrapper) {
  //     const chart = chartWrapper.getChart();
  //     const eventListener = (e: any) => {
  //       const { row, column } = e;
  //       if (e.type === "onmouseover") {
  //         console.warn("MOUSE OVER ", { row, column });
  //       } else if (e.type === "onmouseout") {
  //         console.warn("MOUSE OUT ", { row, column });
  //       }
  //     };
  //     google.visualization.events.addListener(chart, "onmouseover", eventListener);
  //     google.visualization.events.addListener(chart, "onmouseout", eventListener);

  //     return () => {
  //       google.visualization.events.removeListener("onmouseover");
  //       google.visualization.events.removeListener("onmouseout");
  //     };
  //   }
  // }, []);

  return (
    <div className="App" id="chart1">
      <Chart
        chartType="Sankey"
        width="70vw"
        height="400px"
        data={data}
        options={options}
        legendToggle
      />
    </div>
  );
};
export default SankeyChart;
